import { useMemo } from 'react';
import { getCapabilities, isRunnable, isTvBrowser } from '../helpers/capabilities';
import { useI18n } from '../i18n/I18nContext';

interface DiagnosticsProps {
  onClose: () => void;
}

// Browser feature-support panel shown from the pairing screen, so an installer
// can quickly tell whether the current browser can run the player.
export function Diagnostics({ onClose }: DiagnosticsProps) {
  const { t } = useI18n();
  const caps = useMemo(() => getCapabilities(), []);
  const runnable = isRunnable(caps);
  const isTv = useMemo(() => isTvBrowser(), []);

  return (
    <div className="diag-overlay" onClick={onClose}>
      <div className="diag-panel" onClick={(e) => e.stopPropagation()}>
        <div className="diag-header">{t('diag.title')}</div>

        <ul className="diag-list">
          {caps.map((cap) => (
            <li key={cap.id} className={`diag-row ${cap.ok ? 'ok' : 'bad'}`}>
              <span className="diag-icon">{cap.ok ? '✓' : '✕'}</span>
              <span className="diag-label">{t(`diag.${cap.id}`)}</span>
              <span className="diag-tag">
                {cap.required ? t('diag.required') : t('diag.optional')}
              </span>
            </li>
          ))}
          <li className="diag-row info">
            <span className="diag-icon">{isTv ? '📺' : '🖥'}</span>
            <span className="diag-label">{t('diag.playbackMode')}</span>
            <span className="diag-tag">
              {isTv ? t('diag.tvMode') : t('diag.standardMode')}
            </span>
          </li>
        </ul>

        <div className={`diag-summary ${runnable ? 'ok' : 'bad'}`}>
          {runnable ? t('diag.allOk') : t('diag.missing')}
        </div>

        <button className="pairing-retry" onClick={onClose}>
          {t('diag.close')}
        </button>
      </div>
    </div>
  );
}
